export default "__VITE_ASSET__Cq4ZQm0g__"